import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import { icon } from './ui';
import { portalEvent, portalUrl } from './portalApi';
export default class ThreadEnhancements extends Component {
  data = {
    rating: {},
    recent: []
  };
  selected = 0;
  message = '';
  oninit(v) {
    super.oninit(v);
    this.load();
  }
  async load() {
    try {
      this.data = await app.request({
        method: 'GET',
        url: portalUrl('thread', {
          id: this.attrs.discussionId
        })
      });
      m.redraw();
    } catch {}
  }
  async rate(value) {
    if (!app.session.user) {
      this.message = 'Zaloguj się, aby ocenić wątek.';
      return;
    }
    try {
      await portalEvent({
        action: 'rating',
        discussion_id: this.attrs.discussionId,
        rating: value
      });
      this.selected = value;
      this.message = 'Dziękujemy za ocenę.';
      await this.load();
    } catch {
      this.message = 'Nie udało się zapisać oceny.';
    }
    m.redraw();
  }
  view() {
    return m("aside", {
      className: "NtThreadTools"
    }, m("section", null, m("small", null, "OCE\u0143 W\u0104TEK"), m("div", null, [1, 2, 3, 4, 5].map(value => m("button", {
      className: value <= (this.selected || Math.round(Number(this.data.rating?.average || 0))) ? 'active' : '',
      onclick: () => this.rate(value),
      "aria-label": `${value} gwiazdek`
    }, icon('fas fa-star')))), m("span", null, this.data.rating?.average || '—', " / 5 \u2022 ", this.data.rating?.votes || 0, " g\u0142os\xF3w"), this.message ? m("em", null, this.message) : null), m("section", null, m("small", null, "W TEJ CZ\u0118\u015ACI FORUM"), (this.data.related || []).map(row => m(Link, {
      href: `/t/${row.slug}`
    }, icon('far fa-folder-open'), m("span", null, row.name))), (this.data.recent || []).map(row => m(Link, {
      href: `/d/${row.id}-${row.slug}`
    }, icon('far fa-clock'), m("span", null, row.title)))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/ThreadEnhancements', ThreadEnhancements);